import React from "react";
import { Grid, TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import { Box, Button, Paper } from "@material-ui/core";
import styles from "./style";
import { ERROR, ID, REQUIRED_FIELD, SOMETHING_WENT_WRONG, SUCCESS, TRANSFER_PROMOTION_TYPE, } from "../../../../utils/constants";
import CustomSelect from "../../../../components/custom-select/CustomSelect";
import NepaliCalender from "../../../../components/nepali-calender";
import { useEffect } from "react";
import PIS, { API_URL } from "../../../../api/api";
import AddAlertMessage from "../../../../components/alert/Alert";
import { AppUtils } from "../../../../utils/appUtils";

const AddTransferAndPromotionDetails = ({ transferAndPromotionDetails, onCurrentServiceDetailsUpdate }) => {
  const { register, setValue, handleSubmit, formState: { errors }, } = useForm();
  const staffId = AppUtils.getUrlParam(ID);
  const classes = styles();

  useEffect(() => {
    register({ name: "transferOrPromotionType" }, { required: true });
    register({ name: "effectiveDate" }, { required: true });
    register({ name: "decisionDate" }, { required: true });
  }, [register]);

  useEffect(() => {
    if (transferAndPromotionDetails) {
      setValue("transferOrPromotionType", transferAndPromotionDetails.transferOrPromotionType);
      setValue("previousOffice", transferAndPromotionDetails.previousOffice);
      setValue("previousPosition", transferAndPromotionDetails.previousPosition);
      setValue("newOffice", transferAndPromotionDetails.newOffice);
      setValue("newPosition", transferAndPromotionDetails.newPosition);
      setValue("effectiveDate", transferAndPromotionDetails.effectiveDate);
      setValue("decisionDate", transferAndPromotionDetails.decisionDate);
      setValue("remarks", transferAndPromotionDetails.remarks);
    }
  }, [transferAndPromotionDetails]);

  const onSubmit = (data) => {
    data.staffId = AppUtils.getUrlParam(ID);
    const payload = {
      id: staffId,
      transferAndPromotionDetails: {
        transferOrPromotionType: data.transferOrPromotionType,
        decisionDate: data.decisionDate,
        effectiveDate: data.effectiveDate,
        previousOffice: data.previousOffice,
        previousPosition: data.previousPosition,
        newOffice: data.newOffice,
        newPosition: data.newPosition,
        remarks: data.remarks,
      },
    };

    PIS.post(API_URL.staff, payload)
      .then((response) => {
        AddAlertMessage({
          type: response.data.type,
          message: response.data.message,
        });
        if (response.data.type === SUCCESS) {
          onCurrentServiceDetailsUpdate();
        }
      })
      .catch((error) => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };


  const handleCustomSelectChange = (name, value) => {
    setValue(name, value);
  };

  const handleDateChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  };

  return (
    <Paper className={classes.paper}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <CustomSelect
              label="प्रकार"
              name="transferOrPromotionType"
              options={TRANSFER_PROMOTION_TYPE}
              onChange={handleCustomSelectChange}
              defaultValue={transferAndPromotionDetails.transferOrPromotionType}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="अघिल्लो कार्यालय"
              name="previousOffice"
              variant="outlined"
              size="small"
              inputRef={register({ required: true })}
              fullWidth
            />
            {errors.previousOffice && (
              <span className="error-message">{REQUIRED_FIELD}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="अघिल्लो पद"
              name="previousPosition"
              variant="outlined"
              size="small"
              inputRef={register({ required: true })}
              fullWidth
            />
            {errors.previousPosition && (
              <span className="error-message">{REQUIRED_FIELD}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="हालको कार्यस्थल"
              name="newOffice"
              variant="outlined"
              size="small"
              inputRef={register({ required: true })}
              fullWidth
            />
            {errors.newOffice && (
              <span className="error-message">{REQUIRED_FIELD}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="हालको पद"
              name="newPosition"
              variant="outlined"
              size="small"
              inputRef={register({ required: true })}
              fullWidth
            />
            {errors.newPosition && (
              <span className="error-message">{REQUIRED_FIELD}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <NepaliCalender
              id="effectiveDate"
              name="effectiveDate"
              label="लागू हुने मिति"
              onChange={handleDateChange}
              defaultDate={transferAndPromotionDetails.effectiveDate}
            />
            {errors.effectiveDate && (
              <span className="error-message">{REQUIRED_FIELD}</span>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <NepaliCalender
              id="decisionDate"
              name="decisionDate"
              label="निर्णय मिति"
              onChange={handleDateChange}
              defaultDate={transferAndPromotionDetails.decisionDate}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="कैफियत"
              name="remarks"
              variant="outlined"
              size="small"
              inputRef={register()}
              multiline
              rows={2}
              fullWidth
            />
          </Grid>
        </Grid>
        <Box item="true" textAlign="right" className={classes.btnContainer}>
          {!transferAndPromotionDetails && (
            <Button
              type="reset"
              color="secondary"
              variant="contained"
              className={classes.resetBtn}
            >
              रद्द गर्नुहोस
            </Button>
          )}
          <Button type="submit" color="primary" variant="contained">
            {transferAndPromotionDetails
              ? "रेकर्ड अपडेट गर्नुहोस"
              : "सुरक्षित गर्नुहोस"}
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default AddTransferAndPromotionDetails;
